import axios from "axios";
import {apiRootPath} from "./const";

export function _fetchConfigurations() {
  return axios.get(apiRootPath + `/api/configurations/`);
}